import { c as _c } from "react/compiler-runtime";
export function DrawerDragHandle() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-center px-2 py-3 shrink-0"><div className="bg-gray-800/20 h-[5px] rounded-full w-8" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}